import { combineReducers } from 'redux';

import createReducer from '../../../utils/createReducer';
import {
  UNLEASH_FEATURE_FLAGS_LOAD,
  UNLEASH_FEATURE_FLAGS_LOAD_FAILURE,
  UNLEASH_FEATURE_FLAGS_LOAD_SUCCESS,
  UNLEASH_FEATURE_FLAG_TOGGLE,
} from './types';

const isReady = createReducer(false, {
  [UNLEASH_FEATURE_FLAGS_LOAD]: () => false,
  [UNLEASH_FEATURE_FLAGS_LOAD_FAILURE]: () => true,
  [UNLEASH_FEATURE_FLAGS_LOAD_SUCCESS]: () => true,
});

const items = createReducer(
  {},
  {
    [UNLEASH_FEATURE_FLAGS_LOAD]: () => ({}),

    [UNLEASH_FEATURE_FLAG_TOGGLE]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const flag = draft[payload.id];
      if (flag) {
        flag.isEnabled = !flag.isEnabled;
      }
    },

    [UNLEASH_FEATURE_FLAGS_LOAD_SUCCESS]: (draft, { payload }) => {
      // @ts-expect-error Object is possibly 'undefined'.ts(2532)
      payload.flags.forEach((flag) => {
        // eslint-disable-next-line no-param-reassign
        draft[flag.id] = flag;
      });
    },
  }
);

export default combineReducers({
  isReady,
  items,
});
